// extracted by mini-css-extract-plugin
module.exports = {"card":"insuranceCard_card__kwBKg","image":"insuranceCard_image__VfgQ4"};